<div class="app-container">
  <app-loader *ngIf="isAppLoading$ | async"></app-loader>
  <router-outlet></router-outlet>
</div>
